// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605081001/js/" + chunkId + "." + {"44":"70047a17","225":"1f7db37a","481":"598a882a","486":"06fa7e7e","770":"0c4cc826"}[chunkId] + ".0.1432569398200123.chunk.js";
};